import { render, staticRenderFns } from "./knowledgeForm.vue?vue&type=template&id=71f7c930&scoped=true&"
import script from "./knowledgeForm.vue?vue&type=script&lang=js&"
export * from "./knowledgeForm.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeForm.vue?vue&type=style&index=0&id=71f7c930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f7c930",
  null
  
)

export default component.exports